import veritoneApi from './veritoneApi';
import { get } from 'lodash';

function genGetUserQuery(offset, limit, organizationIds = []) {
  const orgIdQuery = organizationIds.length? `, organizationIds:${organizationIds}`: '';
  return `{
    users(limit: ${limit}, offset: ${offset} ${orgIdQuery}) {
      records {
        id,
        email: name,
        firstName,
        lastName,
        lastLoginDateTime,
        modifiedDateTime,
        status,
        imageUrl
        roles {
          id,
          appName,
          name,
          description
        }
      }
    }
  }`;
};

export async function getOrgUsersApi(urlApi, organizationIds, fetchFromIndex = 0, fetchLimit = 500 ) {
  try {
    const response = await veritoneApi(urlApi.graphql).post(
      '',
      { query: genGetUserQuery(fetchFromIndex, fetchLimit, organizationIds) }
    );
    const users = get(response, 'data.data.users.records', []);
    if (users.length === fetchLimit) {
      const newOffset = fetchFromIndex + fetchLimit;
      const moreUsers = await getOrgUsersApi(urlApi, organizationIds, newOffset, fetchLimit);
      const newUserList = [...users, ...moreUsers.data];
      return { data: newUserList };
    } else {
      return { data: users };
    }
  } catch (error) {
    return { error };
  }
}

export function createTeamApi(urlApi, teamInfo) {
  return veritoneApi(urlApi.baseUrl)
    .post(`/team`, teamInfo)
    .then(response => response.data)
    .catch(error => error);
};

export function updateTeamApi(urlApi, teamInfo) {  
  return veritoneApi(urlApi.baseUrl)
    .put(`/team`, teamInfo)
    .then(response => response.data)
    .catch(error => error);
};

export function deleteTeamApi(urlApi, id) {
  return veritoneApi(urlApi.baseUrl)
    .delete(`/team/${id}`)
    .then(response => response.data)
    .catch(error => error);
};

export function getTeamsApi(urlApi, teamIds = [], orgId) {
  const orgIdQuery = orgId != undefined? `orgId=${orgId}`: '';
  const query = teamIds.length > 0 ? '&teams[]=' + teamIds.join('&teams[]=') : '';
  return veritoneApi(urlApi.baseUrl)
    .get(`/team?${orgIdQuery}${query}`)
    .then(response => response.data)
    .catch(error => error);
};

export function getUsersActivitiesApi(urlApi, userId) {
  return veritoneApi(urlApi.baseUrl)
    .post(`/users/stats`, userId)
    .then(response => response.data)
    .catch(error => error);
};
